module.exports = __webpack_public_path__ + "img/job-professional.0ca6a89d.svg";